import {downloadFile} from "../../../utils/file/download";
import axios from "axios";
import {dateFormatDDMMYYYY} from "../../../utils/formatters/Date";

export class InstitutionService {
    getInstitutions() {
        return axios.get('/appapv/getInstitutions.action', {
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(res => res.data.payload[0]);
    }

    getInstitution(institutionId) {
        return axios.get('/appapv/getInstitution.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                idInstitucion: institutionId
            }
        }).then(res => res.data.payload);
    }

    exportInstitution() {
        return downloadFile('/appapv/getReportInstitutionsXls.action');
    }

    getCatalogsInstitution() {
        return axios.get('/appapv/getCatalogsInstitution.action', {
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(res => res.data);
    }

    updateInstitution(institution, contactList, signList, isUpdate) {
        let url = isUpdate ?
            '/appapv/updateInstitution.action' : '/appapv/insertInstitution.action';
        return axios.post(url,
            {
                listaContactosJson: JSON.stringify(contactList),
                listaFirmasJson: JSON.stringify(signList)
            },
            {
                params: {
                    idInstitucion: isUpdate ? institution.idInstitucion: institution.catInstitution.IdInstFinan,
                    nombreCorto: institution.nombreCorto ?
                        encodeURIComponent((institution.nombreCorto)) : institution.catInstitution.NomInstFinanCorto,
                    razonSocial: encodeURIComponent((institution.razonSocial)),
                    rfc: institution.rfc,
                    status: institution.catStatus.id,
                    numEscCons: institution.numEscCon,
                    fecEsc: dateFormatDDMMYYYY(institution.escrituraFec),
                    regPubComer: institution.recPubComer,
                    fecRegPub: dateFormatDDMMYYYY(institution.regPubFec),
                    noPoder: institution.powerNumber,
                    fecPoder: dateFormatDDMMYYYY(institution.powerDate),
                    fisCalle: encodeURIComponent((institution.fisCalle)),
                    fisColonia: encodeURIComponent((institution.fisColonia)),
                    fisCP: institution.fisCP,
                    fisCiudad: encodeURIComponent((institution.fisCiudad)),
                    fisEstado: encodeURIComponent((institution.fisEstado)),
                    fisPais: encodeURIComponent((institution.fisPais)),
                    corrCalle: encodeURIComponent((institution.corrCalle)),
                    corrColonia: encodeURIComponent((institution.corrColonia)),
                    corrCP: institution.corrCP,
                    corrCiudad: encodeURIComponent((institution.corrCiudad)),
                    corrEstado: encodeURIComponent((institution.corrEstado)),
                    corrPais: encodeURIComponent((institution.corrPais)),
                    contratoServicios: institution.contratoServicios ? 1 : 0,
                    comprobanteDomicilio: institution.comprobanteDomicilio ? 1 : 0,
                    actaConstitutiva: institution.actaConstitutiva ? 1 : 0,
                    comprobanteRFC: institution.comprobanteRFC ? 1 : 0,
                    poderesNotariales: institution.poderesNotariales ? 1 : 0,
                    idInst: institution.idInst,
                    folioInst: institution.folioInst,
                    observaciones: institution.observaciones ?
                        encodeURIComponent((institution.observaciones)) : '',
                    cuentaEfectivo: institution.cuentaEfectivo ? institution.cuentaEfectivo : '',
                    banderaCuentaEfvo: institution.banderaCuentaEfvo ? 1 : 0,
                    idRol: institution.catRole.IdRol,
                    idTipoInstrumento: institution.catInstrument.IdTipoInstrumento ?
                        institution.catInstrument.IdTipoInstrumento : '2',
                    banderaIndeval: institution.banderaIndeval ? 1 : 0,
                    idClienteGSS: institution.catIdClientGss ?
                        institution.catIdClientGss.IDRELCLIENTE : '',
                    idContraparte: institution.idContraparte,
                    contrato: institution.contrato ? institution.contrato : 0,
                    seleccionGaran: institution.seleccionGaran ? 1 : 0,
                    banderaCambioMedio: institution.banderaCambioMedio ?
                        institution.banderaCambioMedio : true,
                    banderaCambioFirma: institution.banderaCambioFirma ?
                        institution.banderaCambioFirma : true,
                    banderaOtc: institution.catTypeLoan.id,
                    contractBBVA: institution.contrato ? institution.contrato : 0,
                    counterBBVAId: isUpdate ? institution.counterBBVAId : institution.catInstitution.IdInstFinan,
                },
            }
        ).then(res => res.data);
    }
}